import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import errorHandler from "@/layout/components/error/ErrorHandler";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { axiosPath } from "../../../../routing/helpers/router";
import Translator from "../../helpers/Translator";
import useIsMounted from "../../hooks/useIsMounted";

export default function ResourceManagerCategorySelect(props) {
  const {
    value,
    onHandleChange,
    className = "",
    isMulti = true,
    hasSearchBox = false,
    hasSelectOptions = false,
  } = props;
  const { moduleBridgeHex } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [categories, setCategories] = useState();
  const [view] = useState(
    location?.pathname?.includes("/obligation/") ? "obligation" : "resource"
  );

  // > LOAD CATEGORIES //
  const loadCategories = useCallback(
    async () =>
      axios
        .post(axiosPath("api_r_user_module_resourceManager_getCategories"), {
          moduleBridgeHex,
          view,
        })
        .then(({ data }) => {
          if (isMounted.current) setCategories(data);
        })
        .catch((e) => dispatch(errorHandler(e))),

    [moduleBridgeHex, view]
  );

  useEffect(() => {
    loadCategories();
  }, [view]);
  // < LOAD CATEGORIES //

  return (
    <AppMultiSelect
      options={categories}
      title={ReactDOMServer.renderToString(
        <Translator file="module-resourceManager" name="resource.tipologies" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-resourceManager"
          name="resource.tipologies-selectOneOrMore"
        />
      )}
      value={value}
      onChange={onHandleChange}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="apps-2" />}
      allowSelectAll
      className={className}
      isLoading={!categories}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
    />
  );
}
